export enum SnackbarIcons {
  SUCCESS = "/icons/checkmark.svg",
  FAILED = "/icons/error.svg",
}
